import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import React, { FunctionComponent } from "react";
import { financialItemStyles } from "./styles/financialItemStyle";
import "../Print.css";

type SalesDataProps = {
  salesData: {
    total_cash_receive_count: number;
    total_cash_receive: number;
    credit_card_total_count: number;
    credit_card_total: number;
    gross_total_amount: number;
    trans_return_total: number;
    disc_total: number;
    total_round_off: any;
    bill_net_total: number;
    loyalityPoint_total_count: any;
    voucher_total_count: any;
    voucher_total_amount: any;
    total_customercredit_count: any;
    total_customercredit_amount: any;
    loyalityPoint_total_amount: any;
    denomination_total_amount: number;
    foreign_currency_total_count: string;
    total_sum_foreign_currency: string;
    local_foreign_currency_total: string;
  };
  source: string;
};

export const CashReceived: FunctionComponent<SalesDataProps> = ({
  salesData,
  source,
}) => {
  const salesAmount =
    salesData.denomination_total_amount - salesData.total_cash_receive;
  const classes = financialItemStyles();
  return (
    <Grid container style={{ paddingTop: "2.4em" }}>
      <Grid item xs={12}>
        <TableContainer>
          <Grid container>
            <Grid item lg={12}>
              <Typography className={classes.title}>Cash Received</Typography>
            </Grid>
          </Grid>
          <Table
            size="small"
            aria-label="a dense table"
            className={source === "print" ? classes.table : ""}
          >
            <TableHead className={classes.tableRow}>
              <TableRow>
                <TableCell
                  align="left"
                  className={classes.headColor}
                  component="th"
                  scope="row"
                  // style={{ width: "25%" }}
                ></TableCell>

                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "25%" }}
                >
                  Bills
                </TableCell>
                <TableCell
                  align="right"
                  className={classes.headCell}
                  style={{ width: "25%" }}
                >
                  Amount
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell className={classes.headCell}>Cash Amount</TableCell>
                <TableCell className={classes.headColor} align="right">
                  {salesData.total_cash_receive_count
                    ? salesData.total_cash_receive_count
                    : "0"}
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {salesData.total_cash_receive
                    ? salesData.total_cash_receive
                    : "0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.headCell}>Card Amount</TableCell>

                <TableCell className={classes.headColor} align="right">
                  {salesData.credit_card_total_count
                    ? salesData.credit_card_total_count
                    : "0"}
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {salesData.credit_card_total
                    ? salesData.credit_card_total
                    : "0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.headCell}>
                  Foreign Currency Amount
                </TableCell>

                <TableCell className={classes.headColor} align="right">
                  {salesData.foreign_currency_total_count
                    ? salesData.foreign_currency_total_count
                    : "0"}
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {salesData.local_foreign_currency_total
                    ? salesData.local_foreign_currency_total
                    : "0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.headCell}>
                  Credit Amount
                </TableCell>

                <TableCell className={classes.headColor} align="right">
                  {salesData.total_customercredit_count
                    ? salesData.total_customercredit_count
                    : "0"}
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {salesData.total_customercredit_amount
                    ? salesData.total_customercredit_amount
                    : "0.00"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell className={classes.headCell}>
                  Voucher Amount
                </TableCell>

                <TableCell className={classes.headColor} align="right">
                  {salesData.voucher_total_count
                    ? salesData.voucher_total_count
                    : "0"}
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {salesData.voucher_total_amount
                    ? salesData.voucher_total_amount.toFixed(2)
                    : "0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.headCell}>
                  Loyality Amount
                </TableCell>

                <TableCell className={classes.headColor} align="right">
                  {salesData.loyalityPoint_total_count
                    ? salesData.loyalityPoint_total_count
                    : "0"}
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {salesData.loyalityPoint_total_amount
                    ? salesData.loyalityPoint_total_amount
                    : "0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  colSpan={2}
                  className={classes.headCell}
                  align="right"
                >
                  Gross Amount
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {salesData.gross_total_amount
                    ? salesData.gross_total_amount
                    : "0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  colSpan={2}
                  className={classes.headCell}
                  align="right"
                >
                  Returns
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {salesData.trans_return_total
                    ? salesData.trans_return_total
                    : "0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  colSpan={2}
                  className={classes.headCell}
                  align="right"
                >
                  Shortage
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {Math.sign(salesAmount) === -1
                    ? salesAmount.toFixed(2)
                    : "0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  colSpan={2}
                  className={classes.headCell}
                  align="right"
                >
                  Excess
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {Math.sign(salesAmount) === 1
                    ? salesAmount.toFixed(2)
                    : "0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  colSpan={2}
                  className={classes.headCell}
                  align="right"
                >
                  Discounts
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {salesData.disc_total ? salesData.disc_total : "0.00"}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell
                  colSpan={2}
                  className={classes.headCell}
                  align="right"
                >
                  Vat Collected
                </TableCell>
                <TableCell className={classes.headColor} align="right">
                  {"0.00"}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  colSpan={2}
                  className={classes.headCell}
                  align="right"
                >
                  Net Amount
                </TableCell>
                <TableCell className={classes.headCell} align="right">
                  {salesData.bill_net_total ? salesData.bill_net_total : "0.00"}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
